import { Badge, Button, Modal } from "../design";
import useTranslator from "../../hooks/useTranslator";
import { getNewStepRows } from "../../helper/tenantRequirements";
import "./NewStepsModal.css";

// What each new step asks the tenant to do. AML runs inside the KYC step, so
// both keys show as one row.
const STEPS = {
  kyc: [
    "identityVerification",
    "Identity verification",
    "newStepKycHint",
    "Verify your identity with a quick ID check.",
  ],
  open_banking: [
    "openBanking",
    "Open Banking",
    "newStepBankHint",
    "Connect your bank so landlords can see your income.",
  ],
  guarantor: [
    "guarantor",
    "Guarantor",
    "newStepGuarantorHint",
    "Add a guarantor to strengthen your profile.",
  ],
  applicant_questions: [
    "newApplicantQuestions",
    "New questions to answer",
    "newStepQuestionsHint",
    "Answer the questions your landlord added.",
  ],
  household: [
    "newHouseholdQuestions",
    "Household and pets questions",
    "newStepHouseholdHint",
    "Tell us about the people and pets in your home.",
  ],
  client_identification: [
    "kycAmlIdentificationForm",
    "KYC-AML identification form",
    "newStepIdentificationHint",
    "Fill in and sign the KYC-AML identification form.",
  ],
};

/**
 * Every new step in one place, opened from the "New on your profile" banner.
 * `keys` are the open new features (getNewTenantFeatures). Each row has its
 * own button.
 */
const NewStepsModal = ({ open, keys, onStart, onClose }) => {
  const { _t } = useTranslator();
  const rows = getNewStepRows(keys);
  return (
    <Modal
      open={open && rows.length > 0}
      onClose={onClose}
      size="md"
      align="start"
      title={_t("newStepsModalTitle", "Steps to complete")}
      description={_t(
        "newStepsModalDescription",
        "Your landlord now asks for more on your profile. Complete these steps."
      )}
    >
      <ul className="new-steps-list">
        {rows.map((row) => {
          const [titleKey, title, hintKey, hint] = STEPS[row];
          return (
            <li key={row} className="new-steps-list__item">
              <div className="new-steps-list__text">
                <p className="new-steps-list__title">
                  {_t(titleKey, title)} <Badge>{_t("newBadge", "New")}</Badge>
                </p>
                <p className="new-steps-list__hint">{_t(hintKey, hint)}</p>
              </div>
              <Button size="sm" variant="outline" onClick={() => onStart(row)}>
                {_t("start", "Start")}
              </Button>
            </li>
          );
        })}
      </ul>
    </Modal>
  );
};

export default NewStepsModal;
